<template>
  <div class="p-filtersA">
    <div class="p-filtersA__left">
      <slot name="select" />
    </div>
    <div class="p-filtersA__right">
      <SwitchDate :current="currentDateId" @click="changeDate" />
      <DatePicker
        :initial-dates="period"
        :disabled-dates="disabledDates"
        opens="left"
        @input="changePeriod"
      />
      <div v-if="visibleExportCsv">
        <KkButton
          class="csvButton"
          color="secondary"
          full
          height="38px"
          :font-bold="false"
          :text="$t('labels.csvDownload')"
          :disabled="disabledExportCsv"
          @click.prevent="setExportCsv"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SwitchDate from '../SwitchDate'
import DatePicker from '../DatePicker'
import { periods } from '../../modules/analysis'
import { KkButton } from '../../components/base'
import { actionEvent } from 'src/biz_spa/modules/googleAnalytics'

export default {
  name: 'CompaniesAnalysisHeader',
  components: {
    SwitchDate,
    DatePicker,
    KkButton
  },
  props: {
    currentDate: {
      type: [Object, String],
      required: true,
    },
    period: {
      type: [Object, Date], // { startDate: Date, endDate: Date } or Date
      default: () => ({
        startDate: new Date(),
        endDate: new Date()
      })
    },
    disabledDates: {
      type: Object,
    },
    visibleExportCsv: {
      type: Boolean,
      default: false
    },
    disabledExportCsv: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change-date', 'change-period', 'export-csv'],
  computed: {
    currentDateId() {
      if (typeof this.currentDate === 'string') return this.currentDate
      return this.currentDate.id
    },
  },
  methods: {
    changeDate(value) {
      if (typeof this.currentDate === 'string') {
        this.$emit('change-date', value)
        return
      }
      this.$emit('change-date', periods.find(v => v.id === value))
    },
    changePeriod(value) {
      this.$emit('change-period', value)
    },
    setExportCsv(){
      this.$emit('export-csv')
      actionEvent('CsvDownload')
    }
  }
}
</script>
<style lang="scss" scoped>
.csvButton {
  margin-left: 10px;
  @media screen and (max-width: 768px) {
    margin-left: 0;
    margin-top: 16px;
  }
}
</style>
